import { Dayjs } from "dayjs";

export default class LandUsePageViewModel {
    gfaFrom?: number = undefined;
    gfaTo?: number = undefined;
    rfaFrom?: number = undefined;
    rfaTo?: number = undefined;
    parkingFrom?: number = undefined;
    parkingTo?: number = undefined;

    siteName?: string = '';
    city?: string = '';

    locationId?: number = undefined;
    subLocationId?: number = undefined;
    useClassId?: number = undefined;

    isMultiModal: boolean | null = false;

    // site filtering 
    sites: string[] = [];
    isAllSelected?: boolean = false;

    serviceVehicles: (string | null)[] = ["Y", null]


    startDate: Dayjs | null = null;
    endDate: Dayjs | null = null;
}